import * as React from "react";
import { forwardRef } from "react";
const SvgRadioActiveIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 2.5, y: 2.5, width: 19, height: 19, rx: 9.5, fill: "#5265FF", stroke: "#182231" }), /* @__PURE__ */ React.createElement("rect", { x: 8, y: 8, width: 8, height: 8, rx: 4, fill: "white" }));
const ForwardRef = forwardRef(SvgRadioActiveIcon);
export { ForwardRef as ReactComponent };
